<template>
  <div class="p-grid p-fluid">
    <div class="p-col-12" style="border-bottom: 2px solid black">
      {{ translate('export.profiles') }}
    </div>
    <div class="p-col-12" style="min-height: 555px; padding: 0px">
      <DataTable :scrollable="true"
                 :selection.sync="gridProfileSelection"
                 :value="getProfiles"
                 class="profile-table"
                 dataKey="id"
                 scroll-height="500px"
                 selectionMode="single"
      >
        <Column>
          <template #body="slotProps">
            <div class="centered-left">
              {{ slotProps.data.profileName }}
              <i v-if="slotProps.data.published" class="pi pi-users"></i>
            </div>
            <div class="centered-right">
              <Button class="p-button-secondary"
                      icon="pi pi-angle-down"
                      :disabled="!authorized(slotProps.data)"
                      v-on:click="searchProfileClick(slotProps.data, $event)"></Button>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
    <ContextMenu ref="menu" :model="items" :visible="true"></ContextMenu>
    <div class="p-col-12">
      <Button :disabled="!isExportActive" :label="translate('button.export')" v-on:click="exportClick"></Button>
      <Button :label="translate('button.create.export.profile')" style="margin-top: 6px"
              @click="createNewProfile"></Button>
      <PickListExport></PickListExport>
    </div>
    <Dialog :header="translate('header.delete.confirmation')" :modal="true" :style="{width: '50vw'}"
            :visible.sync="deleteDialog">
      {{ translate('would.you.delete.the.profile') }} <span
        v-if="clickedProfile != null"> {{ clickedProfile.profileName }}</span>
      <template #footer>
        <Button :label="translate('button.delete')" class="p-button-danger" icon="pi pi-trash"
                @click="deleteConfirmation"/>
        <Button :label="translate('button.cancel')" class="p-button-secondary" icon="pi pi-times"
                @click="deleteDialog=false"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import PickListExport from "../layout/PickListExport";
import {mapActions, mapGetters} from 'vuex';
import TranslateService from "../services/translate.service";
import AvailExcelService from "../services/availexport.service";
import axios from 'axios';
import _ from 'lodash';


export default {

  name: "ExportProfiles",
  components: {PickListExport},
  data() {
    return {
      deleteDialog: false,
      clickedProfile: null,
      currentId: null,
      displayBasic: false,
      gridProfileSelection: null,
      items: [
        {
          label: 'Publish',
          icon: 'pi pi-users',
          command: () => {
            this.publishClick()
          }
        },
        {
          label: 'Depublish',
          icon: 'pi pi-user',
          command: () => {
            this.dePublishClick()
          }
        },
        {
          separator: true
        },
        {
          label: 'Edit',
          icon: 'pi pi-pencil',
          command: () => {
            this.editProfile()
          }
        },
        {
          label: 'Delete',
          icon: 'pi pi-trash',
          command: () => {
            this.deleteDialog = true
          }

        }
      ]
    }
  },
  computed: {
    ...mapGetters('search',
        ['getSearchProfiles', 'getAsSearchRequest', 'getCombinedFilters']),
    ...mapGetters('exportpro', ['getProfiles']),
    ...mapGetters('config', ['isAdmin']),
    isExportActive() {
      return this.gridProfileSelection != null;
    }
  },
  methods: {
    ...mapActions('search',
        ['loadSearchProfiles',
          'activateSearchProfile']),
    ...mapActions('exportpro', ['showDialog', 'loadGridProfiles', 'deleteProfile', 'loadCurrentProfile', 'publishProfile', 'dePublishProfile']),

    translate(message) {
      return TranslateService.translateMessage(message);
    },
    exportClick() {
      // let searchRequest = this.getAsSearchRequest;
      let searchRequest = this.getCombinedFilters;
      let columns = JSON.parse(this.gridProfileSelection.profileContent)[0];
      let colNames = [];
      for (let col of columns) {
        colNames.push(col.fieldName);
      }
      let query = {
        availSearchRequest: searchRequest,
        multiResults: [],
        columns: colNames
      }
      AvailExcelService.exportExcel(query).then(r => {
        let fileName = r.data;
        if (fileName !== '') {
          this.downloadWithAxios(fileName);
        }
      });
    },
    forceFileDownload(response, filename) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename) //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadWithAxios(fileName) {
      axios({
        method: 'get',
        url: '/api/export/files/' + fileName,
        responseType: 'arraybuffer'
      })
          .then(response => {
            this.forceFileDownload(response, fileName)
          })
          .catch(() => console.log('error occured'))
    },
    loadSearchProfile() {
      this.activateSearchProfile(this.searchProfileSelection);
    },
    editProfile() {
      this.showDialog()
    },
    createNewProfile() {
      this.loadCurrentProfile(null)
      this.showDialog()
    },
    searchProfileClick(item, event) {
      this.clickedProfile = item;
      this.loadCurrentProfile(item)
      // console.log("jetzt müsste was geladen haben" + JSON.stringify(item))
      this.$refs.menu.show(event);
    },
    deleteConfirmation() {
      this.deleteProfile(this.clickedProfile.id)
      this.deleteDialog = false
    },
    publishClick() {
      this.publishProfile(this.clickedProfile.id);
    },
    dePublishClick() {
      this.dePublishProfile(this.clickedProfile.id);
    },
    authorized(profile) {
      return _.get(profile, "owner", false) || this.isAdmin;
    }
  },
  mounted() {
    //this.loadSearchProfiles();
    this.loadGridProfiles()
  }
}
</script>

<style scoped>

</style>